import { render, staticRenderFns } from "./FileAlertModal.vue?vue&type=template&id=5c64765c&"
import script from "./FileAlertModal.vue?vue&type=script&lang=ts&"
export * from "./FileAlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports